
import { onSuccess } from '../../utils/helper';
import { UPDATE_CURRENT_VIDEO } from '../seeAllPages/constants';
export const updatedCurrentVideo = (data) => onSuccess(UPDATE_CURRENT_VIDEO, data);